/**
 * 공통 코드 API
 */
import { apiClient } from "./client";
import { GetCommonCodeListResponseDto, SlotInfo, slotInfoFromDto } from "../types/commonCode.types";

// 슬롯 정보 캐시 (앱 실행 중 한 번만 조회)
let slotInfoCache: SlotInfo[] | null = null;

export const commonCodeApi = {
    /**
     * 그룹코드별 공통코드 목록 조회
     */
    getCommonCodeList: async (grpCode: string): Promise<GetCommonCodeListResponseDto> => {
        const response = await apiClient.get<GetCommonCodeListResponseDto>(
            '/api/v1/common-code/list',
            { params: { grpCode } }
        );
        return response.data;
    },

    /**
     * SLOTINFO 조회 (슬롯별 요일 기준 건수)
     * 캐시된 데이터가 있으면 캐시 반환
     */
    getSlotInfo: async (): Promise<SlotInfo[]> => {
        // 캐시된 데이터가 있으면 반환
        if (slotInfoCache !== null) {
            return slotInfoCache;
        }

        try {
            const response = await apiClient.get<GetCommonCodeListResponseDto>(
                '/api/v1/common-code/list',
                { params: { grpCode: 'SLOTINFO' } }
            );

            // 사용중인 코드만 필터링하고 순서대로 정렬
            const slotInfoList = response.data.codes
                .filter(code => code.useYn === 'Y')
                .map(slotInfoFromDto)
                .sort((a, b) => a.order - b.order);

            // 캐시에 저장
            slotInfoCache = slotInfoList;

            return slotInfoList;
        } catch (error) {
            return [
                { slotCode: 'SLOT1', slotName: '아침점심피크', order: 1, monday: 21, tuesday: 21, wednesday: 21, thursday: 21, friday: 24, saturday: 31, sunday: 33 },
                { slotCode: 'SLOT2', slotName: '오후논피크', order: 2, monday: 20, tuesday: 20, wednesday: 20, thursday: 20, friday: 21, saturday: 22, sunday: 22 },
                { slotCode: 'SLOT3', slotName: '저녁피크', order: 3, monday: 30, tuesday: 30, wednesday: 30, thursday: 30, friday: 32, saturday: 36, sunday: 35 },
                { slotCode: 'SLOT4', slotName: '심야논피크', order: 4, monday: 29, tuesday: 29, wednesday: 29, thursday: 29, friday: 33, saturday: 31, sunday: 30 },
            ];
        }
    },

    /**
     * 슬롯 정보 캐시 초기화
     */
    clearSlotInfoCache: () => {
        slotInfoCache = null;
    }
};
